import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

@Component({
  selector: 'kt-ek-user-management',
  templateUrl: './ek-user-management.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EkUserManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
